<template>
    <icon-radio-group-input
        :items="options"
        label-key-name="name"
        value-key-name="value"
        icon-key-name="icon"
        variant="block"
        :columns="3"
        has-custom-icons
    />
</template>

<script setup lang="ts">
    import { IconRadioGroupInput } from '@keyvue/one-ui';
    import BullseyeArrowIcon from '@keyvue/one-awesome-icons/icons/regular/bullseye-arrow.svg?component';
    import HandsBoundIcon from '@keyvue/one-awesome-icons/icons/regular/hands-bound.svg?component';
    import ArrowsToLineIcon from '@keyvue/one-awesome-icons/icons/regular/arrows-to-line.svg?component';
    import { AssistentRole } from '@keyvue/one-api-client';

    export interface AssistentRoleOption {
        name: string
        value: string
        icon: any
    }

    const options = [{
        name: AssistentRole.LEAD_GENERATION.label,
        value: [AssistentRole.LEAD_GENERATION.value].join(','),
        icon: BullseyeArrowIcon,
    }, {
        name: AssistentRole.SERVICE.label,
        value: [AssistentRole.SERVICE.value].join(','),
        icon: HandsBoundIcon,
    }, {
        name: 'Beiden',
        value: [AssistentRole.LEAD_GENERATION.value, AssistentRole.SERVICE.value].join(','),
        icon: ArrowsToLineIcon,
    }];
</script>
